<template>
  <b-form-checkbox
    v-model="filter"
    value="Y"
    :name="name"
    :disabled="!filterCounter && !filter"
  >
    {{ $t('filter:bool.' + name) }} ({{ toggleSeperator }})
  </b-form-checkbox>
</template>

<script>
import searchRedirect from 'mixins/composition/search/SearchFunctions';
import getNumberFormat from 'mixins/composition/NumberFormat';

import { BFormCheckbox } from 'bootstrap-vue';
import GtmTools from 'mixins/GtmTools';
import { gtmFilterMapping } from 'config/trackingParams';

export default {
  name: 'BoolFilter',
  i18nOptions: { namespaces: 'filter' },
  components: {
    BFormCheckbox,
  },
  mixins: [GtmTools],

  props: {
    name: {
      required: true,
      type: String,
    },
    // used to toggle between showing and hiding the seperator
    showSeperator: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  setup(_, ctx) {
    const { formatNumber } = getNumberFormat(ctx);
    return { formatNumber, searchRedirect };
  },
  computed: {
    filterCounter() { return this.$store.getters.getSearchFilterCount(this.name); },
    filter: {
      get() {
        return this.$store.getters.getSearchFilter(this.name);
      },
      set(filterState) {
        // bootstrap component returns false then null when unselecting for no apparent reason => intercept!
        if (filterState === null) return;

        const gtmString = gtmFilterMapping.boolfilter[this.name];
        this.dataLayerPush({ event: 'asnnutzung', asnfilter: gtmString });

        searchRedirect({ filters: { [this.name]: ((filterState === false) ? 0 : filterState) }, router: this.$router, delay: 1000 });
        // this.search({ filters: { [this.name]: ((filterState === false) ? 0 : filterState) }, router: this.$router, delay: 1000 });
      },
    },
    // used to toggle between showing and hiding the seperator
    toggleSeperator() {
      return this.formatNumber(this.filterCounter, undefined, { useGrouping: this.showSeperator });
    },
  },
};
</script>
